<template>
  <div class="avatar-overlay">
    <div class="container col-10 mt-5">
      <div class="row">
        <div class="col-12">
          <div class="d-flex justify-content-center flex-column text-center">
            <div class="heading mt-4">Choose an Avatar</div>
            <div class="normalText">You are nearly set up. Choose any avatar</div>
            <div class="normalText">that will be used for your profile.</div>
          </div>

          <div class="col-12">
            <div class="d-flex justify-content-center gap-3 mt-5">
              <img
                  v-for="avatar in avatars.slice(0, 3)"
                  :key="avatar.id"
                  :src="getAvatarImage(avatar)"
                  :alt="`avatar-${avatar.name}`"
                  class="avatar-image"
                  :class="{ 'selected': selectedAvatar === avatar.id }"
                  @click="selectAvatar(avatar.id)"
              />
            </div>
          </div>

          <div class="col-12">
            <div class="d-flex justify-content-center gap-3 mt-3">
              <img
                  v-for="avatar in avatars.slice(3, 6)"
                  :key="avatar.id"
                  :src="getAvatarImage(avatar)"
                  :alt="`avatar-${avatar.name}`"
                  class="avatar-image"
                  :class="{ 'selected': selectedAvatar === avatar.id }"
                  @click="selectAvatar(avatar.id)"
              />
            </div>
          </div>

          <div class="col-12">
            <div class="d-flex justify-content-center gap-3 mt-3">
              <img
                  v-for="avatar in avatars.slice(6, 9)"
                  :key="avatar.id"
                  :src="getAvatarImage(avatar)"
                  :alt="`avatar-${avatar.name}`"
                  class="avatar-image"
                  :class="{ 'selected': selectedAvatar === avatar.id }"
                  @click="selectAvatar(avatar.id)"
              />
            </div>
          </div>

          <div class="d-flex justify-content-center mb-4">
            <div
                class="save d-flex justify-content-center mt-5 p-3 border col-5"
                @click="saveAvatar"
                :class="{ 'disabled': isSaving }"
            >
              <div class="saveFont">{{ isSaving ? 'SAVING...' : 'SAVE' }}</div>
            </div>
          </div>

          <div v-if="errorMessage" class="error-text text-center">
            {{ errorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import DepService from '@/api/services/depService';

export default {
  name: 'ChooseAvatar',
  data() {
    return {
      selectedAvatar: null,
      isSaving: false,
      errorMessage: '',
      avatars: [
        {
          id: 1,
          name: 'afro',
          inactive: require('@/assets/profile/avatar-afro-unselected.png'),
          active: require('@/assets/profile/avatar-afro-selected.png')
        },
        {
          id: 2,
          name: 'guitarbear',
          inactive: require('@/assets/profile/avatar-guitarbear-unselected.png'),
          active: require('@/assets/profile/avatar-guitarbear-selected.png')
        },
        {
          id: 3,
          name: 'headphones',
          inactive: require('@/assets/profile/avatar-headphones-unselected.png'),
          active: require('@/assets/profile/avatar-headphones-selected.png')
        },
        {
          id: 4,
          name: 'monocleman',
          inactive: require('@/assets/profile/avatar-monocleman-unselected.png'),
          active: require('@/assets/profile/avatar-monocleman-selected.png')
        },
        {
          id: 5,
          name: 'radiohead',
          inactive: require('@/assets/profile/avatar-radiohead-unselected.png'),
          active: require('@/assets/profile/avatar-radiohead-selected.png')
        },
        {
          id: 6,
          name: 'skeleton',
          inactive: require('@/assets/profile/avatar-skeleton-unselected.png'),
          active: require('@/assets/profile/avatar-skeleton-selected.png')
        },
        {
          id: 7,
          name: 'trumpetman',
          inactive: require('@/assets/profile/avatar-trumpetman-unselected.png'),
          active: require('@/assets/profile/avatar-trumpetman-selected.png')
        },
        {
          id: 8,
          name: 'violin',
          inactive: require('@/assets/profile/avatar-violin-unselected.png'),
          active: require('@/assets/profile/avatar-violin-selected.png')
        },
        {
          id: 9,
          name: 'woman',
          inactive: require('@/assets/profile/avatar-woman-unselected.png'),
          active: require('@/assets/profile/avatar-woman-selected.png')
        }
      ]
    }
  },
  computed: {
    ...mapState(['msisdn', 'productId'])
  },
  methods: {
    ...mapMutations(['setUser', 'setIsLoading']),

    selectAvatar(avatarId) {
      this.selectedAvatar = avatarId;
      this.errorMessage = '';
    },

    async saveAvatar() {
      if (!this.selectedAvatar) {
        this.errorMessage = 'Please select an avatar first!';

        return;
      }

      if (this.isSaving) return;

      this.isSaving = true;
      this.errorMessage = '';

      try {
        const selected = this.avatars.find(avatar => avatar.id === this.selectedAvatar);

        await DepService.updateAvatarFromMsisdn(
            this.msisdn,
            this.productId,
            selected.name
        );

        const response = await DepService.getUserViaProductId(
            this.msisdn,
            this.productId
        );

        const user = response.data.user;

        this.setUser(user);

        localStorage.setItem('avatar', user.avatar);

        this.$emit('avatar-selected', selected.active);
        this.$emit('close');

        this.$router.push('/profile');

      } catch (error) {
        console.error('Error saving avatar:', error);
        this.errorMessage = 'Failed to save avatar. Please try again.';
      } finally {
        this.isSaving = false;
      }
    },

    getAvatarImage(avatar) {
      return this.selectedAvatar === avatar.id ? avatar.active : avatar.inactive;
    }
  },
  mounted() {
    const savedAvatarId = localStorage.getItem('selectedAvatarId');

    if (savedAvatarId) {
      this.selectedAvatar = parseInt(savedAvatarId);
    }
  }
}
</script>

<style scoped>
.container {
  background: #000F56;
  border-radius: 20px;
}

.save {
  background-color: #FFCB05;
  border-radius: 28px;
  cursor: pointer;
  transition: opacity 0.3s ease;
}

.save:hover {
  opacity: 0.9;
}

.save.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.saveFont {
  font-family: 'Clash Display', sans-serif;
  font-weight: 600;
  font-size: 15px;
  color: #000000;
}

.heading {
  font-family: 'Clash Display', sans-serif;
  font-weight: 700;
  font-size: 23px;
  color: #FFFFFF;
}

.normalText {
  font-family: 'Clash Display', sans-serif;
  font-weight: 500;
  font-size: 13px;
  color: #DCDCDC;
}

.avatar-image {
  cursor: pointer;
  transition: transform 0.3s ease;
  width: 80px;
  height: 80px;
  border-radius: 50%;
}

.avatar-image:hover {
  transform: scale(1.05);
}

.avatar-image.selected {
  transform: scale(1.1);
}

.avatar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #00115742;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.error-text {
  color: #EF151C;
  font-family: 'Clash Display', sans-serif;
  font-size: 14px;
  margin-top: 10px;
}
</style>